import { Box, Tooltip } from "@mui/material";
import * as React from "react";
import { customCellRenderNumberComparator, customComparator } from "../AgGrid/CustomSort";
import { formatDate } from "../../_helpers/utils";

export const headCellss = [
  {
    field: "Title",
    headerName: "Title",
    sortable: true,
    suppressColumnsToolPanel: true,
    filter: "agTextColumnFilter",
    comparator: customComparator,
  },
  {
    field: "Description",
    headerName: "Description",
    sortable: true,
    suppressColumnsToolPanel: true,
    filter: "agTextColumnFilter",
    comparator: customComparator,
  },
  {
    field: "Type",
    headerName: "Type",
    sortable: false,
    filter: false,
  },
  {
    field: "ExecuteParallel",
    headerName: "Execute In Parallel",
    sortable: false,
    filter: false,
    cellRenderer: ExecuteParallel,
  },
  {
    field: "TestNames",
    headerName: "Total DQ rules",
    sortable: true,
    filter: false,
    cellRenderer: totalTests,
    comparator: customCellRenderNumberComparator,
  },
  {
    field: "Active",
    headerName: "Active",
    sortable: false,
    filter: false,
    cellRenderer: Active,
  },
  {
    field: "CreatedDate",
    headerName: "Created Date",
    sortable: true,
    filter: false,
    cellRenderer: createdDate,
  },
  {},
];

function ExecuteParallel(props) {
  return <>{props.data.ExecuteParallel.toString()}</>;
}

function createdDate(props) {
  return <>{formatDate(props.data.CreatedDate)}</>;
}

function totalTests(props) {
  return (
    <Tooltip
      title={
        <React.Fragment>
          {props.data.TestNames.map((obj, index) => {
            return (
              <div key={index}>
                {index + 1}.{obj.TestName}
              </div>
            );
          })}
        </React.Fragment>
      }
      placement="top-end"
      arrow>
      <Box>{props.data.TestIds.length}</Box>
    </Tooltip>
  );
}

function Active(props) {
  return <>{props.data.Active.toString()}</>;
}
